(function menuItemsScript($, Drupal) {
  Drupal.behaviors.menuItems = {
    attach(context) {
      
    }
  };
})(jQuery, Drupal);
